import { FinanceProductType } from '../../../../api/types';

export const financingGroup = [
    FinanceProductType.HirePurchase,
    FinanceProductType.HirePurchaseWithBalloon,
    FinanceProductType.HirePurchaseWithBalloonGfv,
    FinanceProductType.DeferredPrincipal,
    FinanceProductType.LeasePurchase,
];

export const leasingGroup = [FinanceProductType.Lease, FinanceProductType.UcclLeasing];

export const includesFinancing = (type: FinanceProductType) =>
    financingGroup.includes(type) || type === FinanceProductType.UcclLeasing;

export const includesLeasing = (type: FinanceProductType) =>
    type !== FinanceProductType.UcclLeasing && leasingGroup.includes(type);
